import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import api from '~/api'
import actions, { TYPES } from '~/actions'

function selectState(state) {
  return {
    products: state.app.searchProductResults || state.app.products,
    currentProduct: state.app.currentProduct
  }
}

function ProductDetailsPage({ config, match, position, location }) {
  const { products, currentProduct } = useSelector(selectState)
  const dispatch = useDispatch()

  const fetchProductAndShow = useCallback(
    async (gtin) => {
      dispatch(actions.loadingProduct(true))

      const searchParams = position.getParams()
      let product

      if (products) {
        product = products.find((i) => i.gtin === gtin)
      }

      if (!product) {
        product = (await api.search({ ...searchParams, gtin }))[0]
      }

      dispatch(
        actions.openDrawerProduct({
          product,
          buyOnline: config.buyOnline,
          fixedLink: config.fixedLink,
          disableFind: !!currentProduct
        })
      )

      dispatch(actions.loadingProduct(false))

      dispatch(actions.updateApp({ view: TYPES.VIEW_STORES }))
    },
    [products, currentProduct, position.fetched]
  )

  useEffect(() => {
    fetchProductAndShow(match.params.gtin)
  }, [location.key, position.fetched])

  return null
}

export default ProductDetailsPage
